import styled from 'styled-components';
import { minBp, theme } from '@triumph/shared';
import RichText from 'components/_utility/RichText/RichText';
import _ArrowRight from '@material-ui/icons/KeyboardArrowRight';
import { Title as _Title } from 'components/FinanceOptionSummary/FinanceOptionSummary.styled';

export const Wrap = styled.div``;

export const Title = styled.button`
  background-color: ${theme.colors.heading};
  border: none;
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: ${theme.fonts.dinDemi};
  font-size: 17px;
  padding: 10px 24px;
  text-align: left;
  width: 100%;

  ${({ isOpen }) => `
    ${
      isOpen
        ? `
        svg {
          transform: rotate(180deg);
        }
    `
        : ``
    }
  `}
`;

export const Content = styled.div`
  ${({ isOpen, isSummaryPage }) => `
    display: ${isOpen ? 'block' : 'none'};
    padding: ${isSummaryPage ? 0 : '22px 22px 0'};
  `}
`;

export const List = styled.ul`
  display: inline-block;
  margin: 0 0 40px;
  padding: 0;
  width: 100%;

  &:last-of-type {
    margin-bottom: 30px;
  }

  @media ${minBp('desktop')} {
    margin-bottom: 0;
    columns: 2;
    column-gap: 34px;

    &:first-of-type {
      display: block;
    }

    &:nth-of-type(2) {
      margin-bottom: 20px;
    }

    &:last-of-type {
      margin-bottom: 40px;
    }
  }
`;

export const ListItem = styled.li`
  display: flex;
  gap: 1.5rem;
  justify-content: space-between;
  padding: 0 0 10px;
  margin: 0 0 20px;
  font-size: inherit;
  letter-spacing: normal;
  border-bottom: 1px solid #d5d5d5;

  &:before {
    content: unset;
  }
`;

export const ListItemLabel = styled.span`
  ${({ $highlight, theme }) =>
    $highlight &&
    `
      font-size: 20px;
      font-weight: bold;
      color: ${theme.colors.heading};
    `}
`;

export const ListItemValue = styled.b`
  color: ${theme.colors.heading};
  flex-shrink: 0;
  white-space: nowrap;
  color: ${theme.colors.heading};
  ${({ $highlight }) => $highlight && `font-size: 20px;`}
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Button = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-family: inherit;
  font-size: 15px;
  padding: 0;
  position: relative;
  text-transform: uppercase;

  ${({ primary }) => `
    color: ${primary ? theme.colors.buttons.primary : theme.colors.buttons.default};
    font-family: ${primary ? theme.fonts.dinRegular : theme.fonts.dinDemi};
    padding-right: ${primary ? '0' : '15px'};
  `}
`;

export const ArrowRight = styled(_ArrowRight)`
  color: ${theme.colors.buttons.primary};
  position: absolute;
  top: -1px; // Offset to align with font baseline
  right: -8px;
`;

export const Summary = styled(RichText)`
  border-top: 1px solid ${theme.colors.hairline};
  margin-top: 27px;
  padding-top: 18px;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 18px;

  p {
    font-size: 12px;
    letter-spacing: 0;
    line-height: 18px;
  }

  @media ${minBp('desktop')} {
    margin-top: 40px;
    padding-top: 30px;
  }
`;

export const TitleAlt = styled(_Title)`
  margin-bottom: 42px;
`;
